<template>
    <accordion-section title="Brand" :loading="loading">
        <b-field horizontal label="Brand">
            <b-autocomplete :data="getFilteredBrands()"
                            v-model="brandName"
                            field="name"
                            open-on-focus keep-open disabled></b-autocomplete>
        </b-field>
    </accordion-section>
</template>

<script>
    export default {
        props: {
            product: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: true,
                brands: [],
                brandName: ''
            }
        },
        mounted() {
            axios.get('/brand/index')
                .then(response => {
                    this.brands = response.data;
                    this.brandName = this.product.brand.name
                    this.loading = false;
                })
        },
        methods: {
            getFilteredBrands() {
                return this.brands.filter(brand => {
                    return (
                        brand.name
                            .toString()
                            .toLowerCase()
                            .indexOf(this.brandName.toLowerCase()) >= 0
                    )
                })
            }
        }
    }
</script>